// extracted by mini-css-extract-plugin
module.exports = {"amount":"styles_amount__3yewX","partsBlock":"styles_partsBlock__jqAj5","partsBlockTitle":"styles_partsBlockTitle__H77xj","numberOfPartsLabel":"styles_numberOfPartsLabel__vclFI"};